import sumBy from 'lodash/sumBy'
import moment from 'moment'
import React from 'react'
import { i18n } from '../../index'
import css from './totalSales.css'
import TotalSalesRow from './TotalSalesRow'
import { TotalSalesNote } from './types'
import WeekSummaryRow from './WeekSummaryRow'
export type BudgetItem = {
  budget: number
  totalSales: number
  totalSalesLastYear: number
  date: string
  note: string
}
type Props = {
  data: { budget: BudgetItem[] }
  handleSelectNote: (note: TotalSalesNote) => void
}

const TotalSalesTable = ({ data, handleSelectNote }: Props) => {
  const budget = data.budget
  const fulfilledBudget = budget.filter((day) => day.totalSales > 0)
  const budgetTotal = sumBy(budget, 'budget')
  const fulfilledBudgetTotal = sumBy(fulfilledBudget, 'budget')
  const fulfilledActualTotalLastYear = sumBy(fulfilledBudget, 'totalSalesLastYear')
  const actualTotal = sumBy(budget, 'totalSales')
  const difference = actualTotal - fulfilledBudgetTotal
  const differenceToLastYear = actualTotal - fulfilledActualTotalLastYear
  const rows = budget.map((item, index) => {
    const isSunday = moment(item.date).day() === 0
    const weekData = budget.slice(Math.max(index - 6, 0), index + 1)
    return (
      <React.Fragment key={index}>
        <TotalSalesRow handleSelectNote={handleSelectNote} data={item} />
        {isSunday && <WeekSummaryRow week={moment(item.date).week()} data={weekData} />}
      </React.Fragment>
    )
  })
  return (
    <table className={css.table}>
      <thead>
        <tr>
          <th />
          <th>{i18n.t('reporting.label.totalSales.budget')}</th>
          <th>{i18n.t('reporting.label.totalSales.sales')}</th>
          <th>{i18n.t('reporting.label.totalSales.difference')}</th>
          <th>{i18n.t('reporting.label.totalSales.differenceLastYear')}</th>
          <th>{i18n.t('reporting.label.totalSales.notes')}</th>
        </tr>
      </thead>
      <tbody>
        <tr className={css.monthSummaryRow}>
          <td>{i18n.t('budgetPlanning.table.wholeMonth')}</td>
          <td>{budgetTotal}</td>
          <td>{actualTotal}</td>
          <td>{difference}</td>
          <td>{differenceToLastYear}</td>
          <td></td>
        </tr>
        {rows}
      </tbody>
    </table>
  )
}

export default TotalSalesTable
